import {SubchainGovernanceTokenSymbol} from "./constants";

const translations = {
    en: {
        translation: {
            "navbar": {
                "back": "Back"
            },
            "stake": {
                "title": `Stake ${SubchainGovernanceTokenSymbol} to help secure the ${SubchainGovernanceTokenSymbol} Theta subchain and earn rewards.`,
                "description": `Unstake your ${SubchainGovernanceTokenSymbol} at any time including pending rewards subject to a cooldown period.`,
                "connect_your_wallet": "Connect Your Wallet",
                "available_on_ios_and_android": "Available on iOS and Android",
                "staking_paused": `${SubchainGovernanceTokenSymbol} staking has been temporarily paused.`,
                "disconnect": "Disconnect",
                "connected_to": "Connected to: ",
                "balance": "Balance",
                "staked_plus_rewards": "Staked + reward (est.)",
                "stake": "Stake",
                "unstake": "Unstake",
                "pending_withdrawals": "Pending Withdrawals",
                "claim": "Claim",
                "available_in": "Available in ~{{time}}",
                "available_to_claim": "Available to claim",
                "available_to_claim_legacy": "Available to claim - Legacy",
            },
            "claim": {
                "title": "Burn 'GroveWars Commemorative' NFTs in exchange for $GROVE tokens",
                "description": null,
                "connect_wallet": "Connect Your Wallet",
                "available_on_ios_and_android": "Available on iOS and Android",
                "paused_message": `${SubchainGovernanceTokenSymbol} claiming has been temporarily paused.`,
                "disconnect": "Disconnect",
                "burn_title": `Burn and Redeem $${SubchainGovernanceTokenSymbol}`,
                "balance": "Balance",
                "stake": `Stake Your ${SubchainGovernanceTokenSymbol}`,
                "burn_all": "Burn All",
                "burn": "Burn",
                "all": "All",
                "owned": "Owned",
                "enter_amount": "Enter",
                "no_nfts": {
                    "title": "No GroveWars NFTs to Burn",
                    "subtitle": "Make sure to withdraw your GroveWars Commemorative NFTs from ThetaDrop to a compatible wallet like MetaMask or ThetaWallet (iOS / Android)",
                    "button": "Open ThetaDrop"
                },
            },
            "modals": {
                "stake": {
                    "title": "Stake",
                    "balance": "Balance",
                    "all": "ALL",
                    "enter_amount": "Enter amount",
                    "stake": "Stake",
                    "insufficient_balance": "Insufficient balance",
                    "enter_valid_amount": "Please enter a valid amount",
                },
                "unstake": {
                    "title": "Unstake",
                    "staked": "Staked",
                    "enter_percentage": "Enter %",
                    "unstake": "Unstake",
                    "cooldown_message": `*${SubchainGovernanceTokenSymbol} will be claimable after ~5 day cooldown`
                }
            },
            "cta": {
                "stake_apy": {
                    "title": `Stake ${SubchainGovernanceTokenSymbol} and earn up to `
                },
                "stake_apy_info": {
                    "title": `Stake ${SubchainGovernanceTokenSymbol} and earn up to `,
                }
            }
        }
    }
};


export default translations;